import axiosInstance from '../axios/axiosInstance';

export const getContactUs = () => axiosInstance.get('common/contactus2');
